import {logError} from '../fingerprint.js';

/**
 * Размечает ссылки и кнопки параметром lfid. Возвращает хэндл setFid,
 * чтобы после ранней разметки сохранённым fid можно было обновить
 * разметку свежим fid от трекера без второго MutationObserver.
 * @param {string} fid
 * @param {string[]} allowedLinks
 * @param {Window} window
 * @returns {{setFid: function(string): void}}
 */
function enhanceLinks(fid, allowedLinks, window) {
    let currentFid = fid;

    function addParamToUrl(url, param, value) {
        try {
            const urlObj = new URL(url);
            if (allowedLinks.some(link => urlObj.href.includes(link))) {
                urlObj.searchParams.set(param, value);
                return urlObj.toString();
            }
        } catch (e) {
            logError(e);
            return url;
        }
        return url;
    }

    function processElements(reprocessAll) {
        const selector = reprocessAll
            ? 'a[href], button'
            : 'a[href]:not([data-fid-processed]), button:not([data-fid-processed])';
        window.document.querySelectorAll(selector).forEach(el => {
            if (el.tagName === 'A') {
                el.href = addParamToUrl(el.href, 'lfid', currentFid);
            } else if (el.tagName === 'BUTTON') {
                const onClickAttr = el.getAttribute('onclick');
                if (onClickAttr && allowedLinks.some(link => onClickAttr.includes(link))) {
                    el.setAttribute('onclick', addParamToUrl(onClickAttr, 'lfid', currentFid));
                }
            }
            el.setAttribute('data-fid-processed', 'true');
        });
    }

    processElements(false);

    const observer = new MutationObserver(() => processElements(false));
    // documentElement — на случай раннего вызова, когда body ещё не создан
    observer.observe(window.document.body || window.document.documentElement, { childList: true, subtree: true });

    return {
        setFid(nextFid) {
            if (typeof nextFid !== 'string' || !nextFid || nextFid === currentFid) {
                return;
            }
            currentFid = nextFid;
            processElements(true);
        },
    };
}

export default enhanceLinks;